import React, { useEffect, useRef, useState } from 'react';
import { useYotpo } from '../../../utils/useYotpo';
import styles from './InstagramProductSlider.module.scss';

const InstagramProductSlider = ({ productID, title, titleLink, link }) => {
  const { getInstaProductBlock } = useYotpo();
  const idInstaProductBlock = getInstaProductBlock();
  const [activeSliders, setActiveSliders] = useState(0);
  const elementRef = useRef(null);

  useEffect(() => {
    if (window.yotpo && elementRef?.current?.children.length === 0) {
      window.yotpo.initWidgets();
    }
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries, observerInstance) => {
        entries.forEach((entry) => {
          if (
            entry.isIntersecting &&
            window.yotpo &&
            elementRef?.current?.children.length
          ) {
            setActiveSliders(elementRef?.current?.children?.length);
            window.yotpo.refreshWidgets();
            // Stop observing once the block is visible
            observerInstance.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: '300px',
        threshold: 0,
      },
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, []);

  return (
    <div>
      {activeSliders ? (
        <div className={styles.instaHeader}>
          <h3>{title}</h3>
          <a
            href={link?.target}
            target={
              link?.mode && link.mode === 'new_window' ? '_blank' : '_self'
            }
          >
            {titleLink}
          </a>
        </div>
      ) : null}
      <div
        ref={elementRef}
        className="yotpo yotpo-pictures-widget"
        data-gallery-id={idInstaProductBlock}
        data-product-id={productID}
      />
    </div>
  );
};
export default InstagramProductSlider;
